<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      custom-selection
      :stripe="false"
      right-toolbar-hide
      row-key="id"
      :reset-data="resetDataFn"
      :before-query-search="beforeQuerySearch"
      lazy
      :load="loadMethod"
      :row-style="$treeRowStyleFun"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm>
        <!-- #ifndef OPEN-SOURCE -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessOrderPreemptGoodsSku.preemptionStatus')" prop="preemptionStatus">
            <BjSelectLov
              v-model="queryParams.preemptionStatus"
              constant-key="ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST"
            />
          </el-form-item>
        </el-col>
        <!-- #endif -->
      </template>
      <template v-if="hasBtn" #startBtnGroup>
        <!-- #ifndef OPEN-SOURCE -->
        <el-button v-if="!success" type="primary" @click="onAction($t('BusinessOrderPreemptGoodsSku.reReserve'))">{{ $t('BusinessOrderPreemptGoodsSku.reReserve') }}</el-button>
        <el-button type="primary" @click="onAction($t('BusinessOrderPreemptGoodsSku.Uncamp'))">{{ $t('BusinessOrderPreemptGoodsSku.Uncamp') }}</el-button>
      </template>
      <!-- #endif -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="left"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <span v-else-if="col.prop === 'preemptionStatus' && scope.row.BJ_HAS_CHILD">
                {{ $t(ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST.bjGet(scope.row[col.prop])) }}</span
              >
              <span v-else-if="col.prop === 'preemptionStatus' && !scope.row.BJ_HAS_CHILD">
                {{ $t(ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST.bjGet(scope.row[col.prop])) }}</span
              >

              <template v-else-if="col.prop === 'other'">
                <!-- #ifndef OPEN-SOURCE -->
                <div v-if="scope.row.BJ_HAS_CHILD">
                  <span class="table-other-td-item"> {{ $t('BusinessOrderPreemptGoodsSku.reserve') }}： {{ scope.row.waitPreempCount }}</span>
                  <span class="table-other-td-item">
                    {{ $t('BusinessOrderPreemptGoodsSku.reserveOk') }}： {{ scope.row.preempSuccessCount }}
                  </span>
                  <span class="table-other-td-item"
                    >{{ $t('BusinessOrderPreemptGoodsSku.reserveFail') }}： {{ scope.row.preempFailCount }}</span
                  >
                </div>
                <!-- #endif -->
                <div v-if="!scope.row.BJ_HAS_CHILD">
                  <span class="table-other-td-item"
                    >{{ $t('BusinessOrderPreemptGoodsSku.hangUp') }}：{{
                      $t(ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST.bjGet(scope.row.suspendStatus))
                    }}</span
                  >
                  <span class="table-other-td-item">
                    {{ $t('BusinessOrderPreemptGoodsSku.giveaway') }}：{{ $t(STATUS_YES_NUM.bjGet(scope.row.giftFlag)) }}</span
                  >
                  <!-- #ifndef OPEN-SOURCE -->
                  <span class="table-other-td-item">
                    {{ $t('BusinessOrderPreemptGoodsSku.sourceStatus') }}：
                    {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row.sourceStatus)) }}</span
                  >
                  <span class="table-other-td-item">
                    {{ $t('BusinessOrderPreemptGoodsSku.virtualPosition') }}： {{ scope.row.virtualWarehouseName }}</span
                  >
                  <span class="table-other-td-item"> {{ $t('BusinessOrderPreemptGoodsSku.failReason') }} ：{{ scope.row.failReason }}</span>
                  <!-- #endif -->
                </div>
              </template>

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="onDetail(scope.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>

      <template v-slot:paginationLeft>
        <!-- #ifndef OPEN-SOURCE -->
        <span
          >{{ $t('BusinessOrderPreemptGoodsSku.productLineTotal') }}：{{ counts.goodsQuantity }}；{{ $t('BusinessOrderPreemptGoodsSku.reserve') }}：{{
            counts.waitPreempCount
          }}；{{ $t('BusinessOrderPreemptGoodsSku.reserveOk') }}：{{ counts.preempSuccessCount }}；{{ $t('BusinessOrderPreemptGoodsSku.reserveFail') }}：{{
            counts.preempFailCount
          }}</span
        >
        <!-- #endif -->
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import {
  STATUS_YES_NUM,
  ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
  ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
  ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
} from '@/utils/constants';
const DEFAULT_COUNTS = {
  goodsQuantity: null,
  innerOrderNo: null,
  preempFailCount: null,
  preempSuccessCount: null,
  waitPreempCount: null,
};
export default {
  name: 'BusinessOrderPreemptDetailSkuList',
  components: {},
  mixins: [pageMiXin],
  // eslint-disable-next-line vue/require-prop-types
  props: ['orderId', 'hasBtn', 'success'],
  data() {
    return {
      serial: true,
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST,
      queryApi: orderApi.getPreemptionOrderSkuListByOrder,

      // 查询参数
      queryParams: {
        id: null,
        preemptionStatus: null,
      },
      labelsVersion: 11,
      labelList: [
        // #ifndef OPEN-SOURCE
        {
          label: this.$t('BusinessOrderPreemptGoodsSku.preemptionStatus'),
          prop: 'preemptionStatus',
          isCheck: true,
          disabled: false,
          width: '100',
        },
        // #endif
        // { label: 'goodsPage.spuName', prop: 'spuName', isCheck: true, disabled: false, width: 160 },
        // { label: 'goodsPage.spuCode', prop: 'spuCode', isCheck: true, disabled: false, width: 160 },
        { label: 'goodsPage.skuName', prop: 'skuName', isCheck: true, disabled: false, width: 160 },
        { label: 'goodsPage.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: 160 },
        { label: 'BusinessOrderPreemptGoodsSku.quantity', prop: 'quantity', isCheck: true, disabled: false, width: 80 },

        { label: 'BusinessOrderPreemptGoodsSku.other', prop: 'other', isCheck: true, disabled: false, width: 800 },

        // { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129},
      ],
      selectedRows: null,
      counts: DEFAULT_COUNTS,
    };
  },
  watch: {},
  created() {
    this.queryParams.id = this.orderId;
  },
  methods: {
    onPreemptSkuLineLog(row) {
      this.$emit('onPreemptSkuLineLog', row);
    },
    resetDataFn(data) {
      return data.map(e => {
        return { BJ_HAS_CHILD: true, BJ_PARENT_ID: null, ...e };
      });
    },
    beforeQuerySearch(conditionObj) {
      orderApi.getPreemptionOrderSkuCountByOrder(conditionObj).then(res => {
        this.counts = Object.assign({}, DEFAULT_COUNTS, res || {});
      });

      return new Promise(resolve => {
        resolve(conditionObj);
      });
    },
    handleSelectionChange(data) {
      /** 商品 */
      this.selectedRows = data;
    },
    onAction(action) {
      const hasChildren = true;
      this.$emit('onAction', action, hasChildren, this.selectedRows);
    },
    loadMethod({ row }) {
      // 异步加载子节点
      return new Promise((resolve, reject) => {
        orderApi
          .getPreemptionOrderSkuLineListBySku({
            itemId: row.id,
          })
          .then(res => {
            const TEMP = (Array.isArray(res) ? res : []).map(e => {
              return { ...e, BJ_HAS_CHILD: false, BJ_PARENT_ID: row.id };
            });

            if (TEMP.length) {
              resolve(TEMP);
            } else {
              this.$message.warning(this.$t('BusinessOrderPreemptGoodsSku.msgWarning'));
              reject();
            }
          });
      });
    },
    onSkuLineLog() {},
  },
};
</script>
